import Marquee from "react-fast-marquee";
import { t } from "../i18n";

export default function Ribbon() {
  const items = t.de.marquee;
  return (
    <section data-testid="marquee" className="bg-navy-900 py-8 border-y border-white/5 overflow-hidden">
      <Marquee gradient={false} speed={45} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="text-3xl md:text-5xl font-outfit font-light text-white/90 px-8">{item}</span>
            <span className="text-gold-500 text-2xl md:text-4xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
